//LOCAL. // ========= DESARROLLO =============
const URLDev = "http://localhost:7020/api"; //--Function

//PRODUCCIÓN //================ PUBLICADO ====================
//const URLServidor = "https://pasillosinfinitosfunction.azurewebsites.net/api";
const URLServidor = "https://pasillosinfinitosfunction.azurewebsites.net/api";

// true -> servidor en la nube  ,/,
// false -> servidor local
const urlActive: boolean = true;

//Exportamos para ser utilizado en el llamado con el back-end
const URLExport: string = urlActive ? URLServidor : URLDev;

export default URLExport;

//IP-Local delcliente.
export const IPCliente = "https://api.ipify.org?format=json";